<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="closeModal()")
      .modal-wrapper(@click.self="closeModal()")
        .modal-container(:style="{ width: width + 'px', height: height ?  height + 'px' : 'auto'}", :class="{'container-modal': responsive}")
          div(:style="{...defaultHeaderStyle, ...headerStyle}")
            p.title {{ title }}
            el-button.btn#btn(
              type="text",
              @click="triggerCloseModal()",
              @mouseover.native="hover",
              @mouseout.native="leave",
              :style="getColor",
              size="mini"
            )
              i.material-icons.icon close

          app-vue-perfect-scrollbar(:style="{...defaultBodyStyle, ...bodyStyle}" :settings='settings' v-loading='loading')
            slot(name="body")
            validation-observer(ref='observer', tag='form', v-slot="{ handleSubmit }")
              form(@submit.prevent="onSubmit")
                el-row.margin-bottom-20(type="flex", :gutter="40")
                  el-col(:md="12")
                    validation-provider(
                      ref="numeroEdital",
                      :rules="{required: true}",
                      v-slot="{ errors }",
                      name="numeroEdital"
                    )
                      Label(label="Número do edital:", :required="true")
                      el-input.input(
                        v-model="edital.numeroEdital",
                        :disabled="isFieldsDisabled || hasReabrirButton"
                      )
                      span.error {{ errors[0] }}
                  el-col(:md="20" v-if="!isFieldsDisabled && !hasReabrirButton")
                    div.date-picker-container
                      validation-provider(
                        ref="periodoAbertura",
                        :rules="{required: true}",
                        v-slot="{ errors }",
                        name="periodoAbertura"
                      )
                        Label(label="Período de Abertura", :required="true")
                        div.picker-container
                          el-date-picker(
                              disabled
                              v-model="dateFix"
                              :pickerOptions="pickerOptions"
                              format="dd/MM/yyyy"
                              ).margin-right
                          el-date-picker(
                              placeholder="Data final"
                              v-model="edital.periodoAberturaFinal"
                              :pickerOptions="pickerOptions"
                              format="dd/MM/yyyy"
                              )
                        span.error {{ errors[0] }}
                  el-col(:md="12" v-else)
                    validation-provider(
                      ref="periodoAbertura",
                      :rules="{required: true}",
                      v-slot="{ errors }",
                      name="periodoAbertura"
                    )
                      Label(label="Data de encerramento:", :required="true")
                      el-date-picker(
                        :editable="false"
                        v-model="edital.periodoAberturaFinal"
                        :pickerOptions="pickerOptions"
                        format="dd/MM/yyyy"
                        @change="edital.periodoAbertura[1] = edital.periodoAberturaFinal"
                      )
                      span.error {{ errors[0] }}
                el-row.margin-bottom-20(type="flex", :gutter="40" v-if="!hasReabrirButton")
                  el-col(:md="24")
                    validation-provider(
                      ref="anexoEdital",
                      :rules="{required: edital.anexoEdital.length === 0}",
                      v-slot="{ errors }",
                      name="anexoEdital"
                    )
                      Label(label="Anexar edital:", :required="true")
                      el-upload(
                        class="upload-demo"
                        drag
                        :action='urlUpload'
                        :headers="{ Authorization: token }"
                        :file-list='fileList'
                        :limit = "parseInt('1')"
                        :on-exceed="limitExceeded"
                        :on-success='updateAnexosId'
                        :before-upload='checkFile'
                        :on-remove="removeFile"
                        accept=".pdf"
                      )
                        div.el-upload__text
                          span Permitido apenas um único arquivo.
                          span Arraste e solte ou clique para selecionar um arquivo.
                          span O tamanho máximo é de 15MB.
                          span Formato suportado: pdf.
                      span.error(v-if='edital.anexoEdital.length === 0') {{ errors[0] }}

          div(v-if="hasFooter")
              div(:style="{...defaultFooterStyle, ...footerStyle}")
                slot(name="footer")
                    div.buttons
                        el-button(@click="$emit('closeModal')") Cancelar
                        div.buttons
                          el-button(
                            v-if="!hasReabrirButton"
                            type="primary",
                            key="botao-confirma",
                            @click="cadastrarEdital()"
                          )
                            span {{editalVigente ? 'Editar' : 'Confirmar'}}
                          el-button(v-if="editalVigente && hasEncerrarButton", @click="confirmarEncerrar") Encerrar
                          el-button(v-if="hasReabrirButton", @click="reabrirEdital", type="primary") Finalizar

</template>

<script>

import AppVuePerfectScrollbar from 'vue-perfect-scrollbar';
import { Label, InputPeriodo, AppNotificacao } from 'sicarf-components';
import { saveEdital, getEncerrarEdital, reabrirEdital } from '@/services/editalService';
const defaultBodyStyle = {
  padding: '20px'
}

const defaultFooterStyle = {
  'margin-top': '10px',
  padding: '5px 20px',
  height: '60px'
}

const defaultHeaderStyle = {
  display: 'flex',
  'justify-content': 'space-between',
  'align-items': 'center',
  border: 'none',
  'border-top-left-radius': '10px',
  'border-top-right-radius': '10px',
  height: '50px',
  'background-color': '#289f61',
  'padding-left': '20px',
  'padding-right': '20px'
}

export default {

  components: {
    AppVuePerfectScrollbar,
    Label,
    InputPeriodo
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    title: {
      type: String,
      required: true
    },

    width: {
      type: Number,
      default: 800
    },

    height: {
      type: Number
    },

    closeOutside: {
      type: Boolean,
      default: true
    },

    bodyStyle: {
      type: Object,
      default: () => defaultBodyStyle
    },

    footerStyle: {
      type: Object,
      default: () => defaultFooterStyle
    },

    headerStyle: {
      type: Object,
      default: () => defaultHeaderStyle
    },

    hasFooter: {
      type: Boolean,
      default: true
    },

    responsive: {
      type: Boolean,
      default: false
    },

    editalVigente: {
      type: Object,
      default: null
    },

    isFieldsDisabled: {
      type: Boolean,
      default: false
    },

    hasEncerrarButton: {
      type: Boolean,
      default: true
    },

    hasReabrirButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: false,
      dateFix: '',
      edital: {
        numeroEdital: null,
        periodoAbertura: null,
        periodoAberturaFinal: null,
        anexoEdital: [],
      },
      colorCopy: '#fff',
      hoverColor: '#d8d8d8',
      settings: {
        minScrollbarLength: 20,
        wheelSpeed: 1
      },
      defaultHeaderStyle,
      defaultBodyStyle,
      defaultFooterStyle,
      pickerOptions: {
        disabledDate(date) {
          const hoje = new Date();
          const hojeSemHora = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
          return date < hojeSemHora;
        }
      },
      urlUpload: `${process.env.VUE_APP_ROOT_URL}/publico/documentoCredenciado/upload`,
      token: `Bearer ${sessionStorage.getItem('@jwt')}`,
      fileList: [],
    }
  },

  computed: {
    getColor () {
      if (this.colorCopy) {
        return `color: ${this.colorCopy}`
      }
      return ''
    }
  },

  created () {
    // Corrige problema que faz a rolagem de scroll ser aplicada no background da modal
    document.body.classList.add('modal-open')
  },

  destroyed () {
    document.body.classList.remove('modal-open')
  },

  async mounted () {
    if (this.editalVigente) {
      this.edital.id = this.editalVigente.id
      this.edital.numeroEdital = this.editalVigente.numero;
      this.edital.periodoAbertura = [new Date(this.editalVigente.dataInicio), new Date(this.editalVigente.dataFim)]
      this.edital.periodoAberturaFinal = new Date(this.editalVigente.dataFim)
      if (this.editalVigente.anexo) {
        this.edital.anexo = this.editalVigente.anexo;
        this.edital.anexo.name = this.edital.anexo.nome;
        this.edital.anexoEdital.push(this.edital.anexo);
        this.fileList.push(this.edital.anexo);
      }
    } else {
      this.clearFields()
    }
    this.dateFix = new Date()
  },

  methods: {
    closeModal () {
      if (this.closeOutside) {
        this.triggerCloseModal()
      }
    },

    triggerCloseModal () {
      this.$emit('closeModal')
    },

    async cadastrarEdital() {
      const data = new Date();
      const handleSaveEdital = async (edital) => {
        try {
          const response = await saveEdital(edital);

          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            `Edital ${this.editalVigente ? 'editado' : 'cadastrado'} com sucesso.`)
          this.$emit('finalizar', response)
        } catch (err) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            `Erro ao ${this.editalVigente ? 'editar' : 'cadastrar'} o edital.`);
          this.$emit('finalizar')
        }
      }

      // Se NÃO for edição de Edital
      if (!this.editalVigente) {
        const periodoAbertura = new Date();
        const periodoEncerramento = (this.edital.periodoAberturaFinal);

        periodoEncerramento.setHours(23);
        periodoEncerramento.setMinutes(59);
        periodoEncerramento.setSeconds(59);

        this.edital.periodoAbertura = [periodoAbertura, periodoEncerramento]

        const valid = await this.$refs.observer.validate();

        if (valid) {
          this.loading = true;
          this.edital.anexo = this.edital.anexoEdital[0];

          if (periodoEncerramento > periodoAbertura) {
            await handleSaveEdital(this.edital);
            this.triggerCloseModal();
          } else {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.DATA_MODAL_EDITAL_INVALIDA);
          }
        }
      } else {
        // TODO: Validar anexo que virá do back e exibi-lo no fronts
        this.edital.periodoAbertura[1] = +new Date(this.edital.periodoAberturaFinal);
        new Date(this.edital.periodoAbertura[1]).setHours(23);
        new Date(this.edital.periodoAbertura[1]).setMinutes(59);
        new Date(this.edital.periodoAbertura[1]).setSeconds(59);

        const valid = await this.$refs.observer.validate();

        // Altera o caminho do arquivo apenas para o nome, para que no back não haja uma concatenação com o caminho antigo, gerando erro.
        const nameAnexo = this.edital.anexo.caminho.split('/');
        this.edital.anexo.caminho = nameAnexo[nameAnexo.length - 1]

        if (valid) {
          this.loading = true;

          // Valida se o prazo do periodo de abertura é igual ou superior a 1 dia do dia atual
          if (this.edital.periodoAberturaFinal >= data.getTime()) {
            await handleSaveEdital(this.edital);
            this.triggerCloseModal();
          } else {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.DATA_MODAL_EDITAL_INVALIDA);
          }
        }
      }

      this.loading = false;
    },

    hover () {
      this.colorCopy = this.hoverColor
    },

    leave () {
      this.colorCopy = this.cor
    },

    limitExceeded() {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.LIMITE_EXCEDIDO_ARQUIVO);
    },

    updateAnexosId(file, response) {
      this.edital.anexoEdital.push({ nome: response.name, caminho: file });
      this.edital.anexo = { nome: response.name, caminho: file };
    },

    removeFile(file) {
      this.edital.anexoEdital = this.edital.anexoEdital.filter((doc) => doc.nome !== file.name);
    },

    checkFile(file) {
      this.loading = true;
      const tamanhoValido = file.size / 1024 / 1024 < 15;
      const formatoValido = file.type === 'document/pdf' ||
                            file.type === 'application/pdf';
      if (!tamanhoValido) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.ARQUIVO_INVALIDO_TAMANHO);
        this.loading = false;
        return false;
      }
      if (!formatoValido) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.ARQUIVO_INVALIDO_FORMATO);
        this.loading = false;
        return false;
      }
      this.loading = false;
      return true;
    },

    async encerrarEditalVigente() {
      await getEncerrarEdital()
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Edital encerrado com sucesso.')
      this.triggerCloseModal()
      this.$emit('finalizar', null)
    },

    async confirmarEncerrar () {
      this.confirmBox(this.$messages.ENCERRAR_EDITAL, this.$messages.TITULO_WARNING,
        () => {
          this.encerrarEditalVigente()
        },
        () => {})
    },

    setDateEdital(value) {
      value.dataFim.setHours(23)
      value.dataFim.setMinutes(59)
      value.dataFim.setSeconds(59)
    },

    async reabrirEdital() {
      const today = new Date()

      // Valida se o prazo do periodo de abertura é igual ou superior a 1 dia do dia atual
      if (this.edital.periodoAberturaFinal >= today.getTime()) {
        let edital = { id: this.editalVigente.id, dataFim: this.edital.periodoAberturaFinal }
        this.setDateEdital(edital)

        try {
          await reabrirEdital(edital)
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Sucesso ao reabrir Edital.')
          this.$emit('finalizar', null)
        } catch (err) {
          console.error(err)
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao reabrir o edital.');
        }
      } else {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.DATA_MODAL_EDITAL_INVALIDA);
      }
    },

    handleReabrirEdital() {
      this.confirmBox(this.$messages.REABRIR_EDITAL, this.$messages.TITULO_WARNING,
        () => {
          this.reabrirEdital()
        },
        () => {})
    },

    clearFields () {
      this.edital = {
        numeroEdital: null,
        periodoAbertura: null,
        periodoAberturaFinal: null,
        anexoEdital: [],
      }
    },

  }

}

</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  margin-top: 8vh;
}

.container-modal {

  @media (min-width: 320px) {
    width: 320px !important;
  }

  @media (min-width: 375px) {
    width: 375px !important;
  }

  @media (min-width: 425px) {
    width: 425px !important;
  }

  @media (min-width: 768px) {
    width: 768px !important;
  }

  @media (min-width: 1366px) {
    width: 768px !important;
  }

}

.modal-container {
  min-height: 200px;
  max-height: 84vh;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 50px;
  background-color: #289f61;
  padding-left: 20px;
  padding-right: 20px;
}

.margin-right {
  margin-right: 10px;
}

.picker-container {
  display: flex;
  width: 100%;
}

.date-picker-container {
  display: flex;
  width: 100%;
  justify-content: center;
}

.modal-footer {
  margin-top: 10px;
  padding: 5px 10px;
  height: 60px;

}

.buttons {
  display: flex;
  justify-content: space-between;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.title {
  font-size: 18px;
  color: #ffffff !important;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 !important;
}

.title-novo {
  font-size: 18px;
  color: #ffffff !important;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.btn {
  padding-right: 5px;
  color: #ffffff;

  .icon {
    font-size: 20px;
    color: #ffffff;
  }
}

section.ps-container.ps {
  height: 100% !important;
}
</style>

<style>
body.modal-open {
  overflow: hidden;
}
</style>
